import React from 'react';
import { useProject } from '../../contexts/ProjectContext';
import ModuleTile from './ModuleTile';

const ModuleGrid = () => {
  const { modules, currentProject } = useProject();

  const activeModules = modules.filter(module => module.status !== 'hidden');

  // Group modules by category
  const modulesByCategory = activeModules.reduce((acc, module) => {
    const category = module.category || 'Other';
    if (!acc[category]) acc[category] = [];
    acc[category].push(module);
    return acc;
  }, {});

  // Sort categories and modules within categories
  const sortedCategories = Object.keys(modulesByCategory).sort();
  
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-slate-900">Apps in this workspace</h2>
        {!currentProject && (
          <div className="text-sm text-amber-600 bg-amber-50 px-3 py-1 rounded-full">
            Select a project to launch apps
          </div>
        )}
      </div>

      <div className="space-y-8">
        {sortedCategories.map(category => (
          <div key={category}>
            <h3 className="text-sm font-medium text-slate-500 uppercase tracking-wide mb-4">
              {category}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {modulesByCategory[category]
                .sort((a, b) => a.order_index - b.order_index)
                .map(module => (
                  <ModuleTile
                    key={module.id}
                    module={module}
                    currentProject={currentProject}
                  />
                ))
              }
            </div>
          </div>
        ))}
      </div>

      {activeModules.length === 0 && (
        <div className="text-center py-12">
          <div className="text-slate-400 text-4xl mb-4">🚀</div>
          <h3 className="text-lg font-medium text-slate-900 mb-2">No apps available</h3>
          <p className="text-slate-500">App modules will appear here once they're configured.</p>
        </div>
      )}
    </div>
  );
};

export default ModuleGrid;